{{#if filter}}
<div class="card-box{{#if isFullScreen}}-backup{{/if}} clearfix">
    {{{FILTER filter}}}
</div>
{{/if}}
